import ArrowUp from '../src/ArrowUp';
export default ArrowUp;
